import { render, staticRenderFns } from "./MentionsLegales.vue?vue&type=template&id=f8ba4c20&scoped=true&"
import script from "./MentionsLegales.js?vue&type=script&lang=js&"
export * from "./MentionsLegales.js?vue&type=script&lang=js&"
import style0 from "./MentionsLegales.scoped.scss?vue&type=style&index=0&id=f8ba4c20&lang=scss&scoped=true&"
import style1 from "./MentionsLegales.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8ba4c20",
  null
  
)

export default component.exports